import triggerTypes from './trigger-types';

export default {
  triggerTypes,
};
